import type { User } from '@supabase/supabase-js';
import Clarity from '@microsoft/clarity';

const CLARITY_PROJECT_ID = 'v4v0ydclxj';
let clarityBooted = false;

export const initClarity = (): void => {
  if (typeof window === 'undefined' || clarityBooted) return;
  Clarity.init(CLARITY_PROJECT_ID);
  clarityBooted = true;
};

export const setClarityConsentV2 = (analyticsAllowed: boolean): void => {
  initClarity();
  const payload = {
    ad_Storage: analyticsAllowed ? 'granted' : 'denied',
    analytics_Storage: analyticsAllowed ? 'granted' : 'denied',
  };

  // Package API differs across versions, so support both.
  const anyClarity = Clarity as any;
  if (typeof anyClarity.consentV2 === 'function') {
    anyClarity.consentV2(payload);
    return;
  }

  if (typeof window !== 'undefined' && typeof window.clarity === 'function') {
    window.clarity('consentv2', payload);
  }
};

export const identifyClarityUser = (user: User): void => {
  initClarity();

  const friendlyName =
    user.user_metadata?.full_name ||
    user.user_metadata?.name ||
    user.email ||
    undefined;

  const anyClarity = Clarity as any;
  if (typeof anyClarity.identify === 'function') {
    anyClarity.identify(user.id, undefined, undefined, friendlyName);
    return;
  }

  if (typeof window !== 'undefined' && typeof window.clarity === 'function') {
    window.clarity('identify', user.id, undefined, undefined, friendlyName);
  }
};
